export default {
    SET_PRIOR_AUTH_BEGIN: 'SET_PRIOR_AUTH_BEGIN',
    SET_PRIOR_AUTH_SUCCESS: 'SET_PRIOR_AUTH_SUCCESS',
    SET_PRIOR_AUTH_ERROR: 'SET_PRIOR_AUTH_ERROR',
    SET_PRIOR_AUTH_CLEANUP: 'SET_PRIOR_AUTH_CLEANUP',
  };
  